import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import type { Channel } from '@entities/channel'
import { Avatar, Button, Flex, Typography } from 'antd'
import { Dialog } from 'antd-mobile'
import * as styles from './mobile-ad-platform.module.scss'

const { Text } = Typography

interface MobileAdPlatformProps {
    adPlatform: Channel
    onDelete: () => void
    onEdit: () => void
}

export const MobileAdPlatform = ({ adPlatform, onDelete, onEdit }: MobileAdPlatformProps) => {
    return (
        <div className={styles.container}>
            <Flex justify="space-between" align="center">
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Avatar src={''} size={40} />
                    <Text style={{ fontSize: '17px', fontWeight: 600 }}>{adPlatform.name}</Text>
                </div>
                <div>
                    <Button
                        type="text"
                        danger
                        style={{ padding: '4px 5px' }}
                        onClick={() =>
                            Dialog.confirm({
                                content: 'Вы уверены что хотите удалить площадку?',
                                cancelText: 'Отмена',
                                confirmText: 'Удалить',
                                onConfirm: onDelete
                            })
                        }
                    >
                        <DeleteOutlined style={{ fontSize: '20px' }} />
                    </Button>
                    <Button type="text" style={{ padding: '4px 5px' }} onClick={onEdit}>
                        <EditOutlined style={{ fontSize: '20px' }} />
                    </Button>
                </div>
            </Flex>
        </div>
    )
}
